<template>
  <div>
    <h3 class="u-mb-20">{{ id ? 'Editar tabela de ingredientes' : 'Nova tabela de ingredientes' }}</h3>

    <el-alert v-if="dados.padrao" class="u-mb-20" type="warning" :closable="false" show-icon
      title="Tabela oficial. Procedência, versão e hash descrevem o arquivo publicado e não são editáveis por aqui — mudam apenas por reimportação."></el-alert>

    <el-form :model="dados" ref="form" label-position="top">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="16">
          <el-form-item label="Nome" prop="nome">
            <el-input v-model="dados.nome" placeholder="Ex.: IBGE — Tabela de Composição Nutricional (POF)"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="8">
          <el-form-item label="Sigla" prop="sigla">
            <el-input v-model="dados.sigla" placeholder="IBGE" :disabled="!!dados.padrao"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :xs="24" :sm="16">
          <el-form-item label="Fonte / publicação">
            <el-input v-model="dados.fonte" :disabled="!!dados.padrao" placeholder="Instituição e publicação de origem"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="8">
          <el-form-item label="Versão / edição">
            <el-input v-model="dados.versao" :disabled="!!dados.padrao"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="dados.sha256">
        <el-col :span="24">
          <el-form-item label="sha256 do arquivo importado">
            <el-input v-model="dados.sha256" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :xs="24" :sm="12">
          <el-form-item label="Tabela oficial">
            <el-switch v-model="dados.padrao" :disabled="!!padraoOriginal"></el-switch>
            <div class="u-fs-12 u-mt-5">Ingredientes de tabela oficial não aceitam edição de valor nutricional.</div>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item label="Ativa">
            <el-switch v-model="dados.situacao"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="u-text-right u-mt-20">
        <router-link to="/admin/merenda/tabela-ingrediente" class="u-mr-10">
          <el-button>CANCELAR</el-button>
        </router-link>
        <el-button type="primary" @click="salvar">SALVAR</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  data: () => ({
    id: null,
    padraoOriginal: false,
    dados: { nome: '', sigla: '', fonte: '', versao: '', sha256: '', padrao: false, situacao: true }
  }),
  mounted () {
    this.id = this.$route.params.id || null
    if (this.id) this.carregar()
  },
  methods: {
    carregar () {
      window.eventBus.$emit('loading', true)
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/tabela-ingrediente/getById/` + this.id, this.$store.getters.getHeaderAuth)
        .then(response => {
          window.eventBus.$emit('loading', false)
          if (response.data && response.data.erro) {
            return window.eventBus.$emit('alert', { msg: response.data.erro, type: 'warning' })
          }
          this.dados = response.data
          this.padraoOriginal = !!response.data.padrao
        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
    },
    salvar () {
      window.eventBus.$emit('loading', true)
      const url = this.id
        ? `${this.$store.state.config.baseUrlApi}/api/merenda/tabela-ingrediente/update/` + this.id
        : `${this.$store.state.config.baseUrlApi}/api/merenda/tabela-ingrediente/store`

      this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth)
        .then(response => {
          window.eventBus.$emit('loading', false)
          if (response.data && response.data.erro) {
            return window.eventBus.$emit('alert', { msg: response.data.erro, type: 'warning' })
          }
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$router.push('/admin/merenda/tabela-ingrediente')
        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
    }
  }
}
</script>
